import FormattedMessage from 'I18n/components/FormattedMessage';
import { getRecipientNameCHIRP } from 'documents-ui/utils/getRecipientName';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DetailViewsZeroStateCHIRP = ({
  contact
}) => {
  const name = contact ? getRecipientNameCHIRP(contact) : '';
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "center",
    direction: "column",
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(DocumentsIcon, {
        size: "900",
        color: "icon-core-disabled"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.detail.views.zeroState.description",
      options: {
        name
      }
    })]
  });
};